// extracted by mini-css-extract-plugin
module.exports = {"affirm":"_5373f15f","affirmInfo":"_e08cd511"};